/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  UpdateBotStrategyByIdOptions,
  UpdateBotStrategyByIdResponses,
} from '../types/UpdateBotStrategyById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Update an existing bot strategy by its unique ID. Only admin users can perform this operation. The request body must contain the updated strategy details.
 * @summary Update Bot Strategy by ID
 * {@link /v1/bot/strategies/:strategy_id}
 */
export function updateBotStrategyById<ThrowOnError extends boolean = true>(
  options: Options<UpdateBotStrategyByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateBotStrategyByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/bot/strategies/{strategy_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateBotStrategyByIdResponses, ThrowOnError>>,
  )
}
